<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <section>
        <!--工具条-->
        <el-row>
            <el-col :span="24" class="toolbar not-print" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-col>
                        <el-form-item label="客户名称:" v-if="me.rname === 'ROLE_PLATFORM' || me.rname === 'ROLE_ADMIN' || me.rname === 'ROLE_DEMO'">
                            <el-select v-model="filters.companyId" filterable clearable placeholder="请选择" @change="companyChange" style="width:180px;">
                                <el-option
                                        v-for="item in companies" :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="区域:">
                            <el-select v-model="filters.groupId" clearable placeholder="请选择" @change="groupChange" style="width:150px;">
                                <el-option
                                        v-for="item in groups" :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="设备名称:" >
                            <el-select v-model="filters.deviceId" clearable placeholder="请选择" style="width:180px;">
                                <el-option
                                        v-for="item in devices"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="日期:" >
                            <el-date-picker
                                    v-model="filters.date"
                                    type="daterange"
                                    :picker-options="pickerOptions0"
                                    placeholder="选择时间"
                                    align="right" style="width:220px;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button :disabled="!filters.date || !(filters.companyId || filters.groupId) || !filters.deviceId" type="primary" v-on:click="getDatas" size="small">查询</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
        <el-col :span="24" >
            <div id="chart1" class="chart3"></div>
        </el-col>

        <el-col :span="24" style="margin-top: 50px;" v-if="visible">
            <el-table :data="fuheData" border highlight-current-row v-loading="listLoading"
                      style="width: 100%;">
                <el-table-column header-align="center" prop="time" label="日期" align="center" width="130">
                </el-table-column>
                <el-table-column header-align="center" prop="fuhe" label="负荷率(%)" width="120" align="center">
                </el-table-column>
                <el-table-column header-align="center" prop="avg" label="平均负荷(kW)" align="center" width="140">
                </el-table-column>
                <el-table-column header-align="center" label="最大负荷(kW)" min-width="160">
                    <el-table-column header-align="center" prop="max" label="值" min-width="60" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" prop="dateMax" label="发生时间" min-width="100" :formatter="formatMaxTime" align="center">
                    </el-table-column>
                </el-table-column>
                <el-table-column header-align="center" label="最小负荷(kW)" min-width="160">
                    <el-table-column header-align="center" prop="min" label="值" min-width="60" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" prop="dateMin" label="发生时间" min-width="100" :formatter="formatMinTime" align="center">
                    </el-table-column>
                </el-table-column>
            </el-table>
        </el-col>
    </section>
</template>
<style scoped>
    .chart3 {
        width: 100% !important;
        height: 300px !important;
        position: relative;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        box-sizing: border-box;
    }
</style>
<script>
    import echarts from 'echarts'
    //import NProgress from 'nprogress'
    import moment from 'moment';
    import {getCompanyList,getGroupList,getDevicesByGroupList,getFuhelvDataList,} from '../../api/api';

    export default{
        data(){
            return{
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                filters: {
                    companyId: '',
                    groupId: '',
                    deviceId: '',
                    date: [
                        moment().startOf('month').hours(0).minutes(0).seconds(0).valueOf(),
                        moment().valueOf()
                    ],
                },
                me: JSON.parse(sessionStorage.getItem('user')),
                companies:[],
                groups:[],
                devices:[],
                fuheData:[],
                listLoading:false,
                visible:false,
                chart1: {},
            }
        },
        methods: {
            formatMaxTime: function (row, column) {
                return moment(row.dateMax).utc().format('HH:mm');
            },
            formatMinTime: function (row, column) {
                return moment(row.dateMin).utc().format('HH:mm');
            },
            companyChange: function (val) {
                this.filters.groupId = '';
                this.filters.deviceId = '';
                this.getGroups(val);
            },
            groupChange: function (val) {
                this.filters.deviceId = '';
                this.getDevicesByGroup(val);
            },
            //获取企业列表
            getCompanies() {
                let para = {
                    name: ''
                };
                //NProgress.start();
                getCompanyList(para).then((res) => {
                    this.companies = res.data.list;
                    if (!this.filters.companyId)
                        this.filters.companyId = this.companies[0].id;
                    //NProgress.done();
                });
            },
            //获取企业列表
            getGroups(company) {
                let para = {
                    companyId: company
                };
                //NProgress.start();
                getGroupList(para).then((res) => {
                    this.groups = res.data.list;
                    this.filters.groupId = this.groups[0].id;
                    if (this.groups.length == 0) {
                        if (this.filters.companyId)
                            this.getDevicesByGroup('');
                    } else {
                        this.getDevicesByGroup(this.groups[0].id);
                    }
                    //NProgress.done();
                });
            },
            getDevicesByGroup(val) {
                let para = {
                    groupId: val
                };
                //NProgress.start();
                getDevicesByGroupList(para).then((res) => {
                    this.devices = res.data.filter(t => !t.deviceId.toUpperCase().startsWith("9"));
                    this.filters.deviceId = this.devices[0].id;
                    this.getDatas();
                    //NProgress.done();
                });
            },
            getDatas() {
                this.listLoading = true;
                this.visible = true;
                this.chart1 = echarts.init(document.getElementById('chart1'));

                let para = {
                    companyId: this.filters.companyId,
                    groupId: this.filters.groupId,
                    deviceId: this.filters.deviceId,
                    dateStart: moment.utc(this.filters.date[0]).valueOf(),
                    dateEnd: moment.utc(this.filters.date[1]).valueOf(),
                };

                getFuhelvDataList(para).then((res) => {

                    var time = res.data.map(t => t.id).reverse();
                    var min = res.data.map(t => t.min.toFixed(2)).reverse();
                    var max = res.data.map(t => t.max.toFixed(2)).reverse();
                    var avg = res.data.map(t => t.avg.toFixed(2)).reverse();
                    var dateMax = res.data.map(t => {
                        return t.maxV[0]
                    }).reverse();
                    var dateMin = res.data.map(t => {
                        return t.minV[0]
                    }).reverse();

                    var sum = res.data.reduce((a, b) => {
                        return a + parseFloat(b.avg.toFixed(2));
                    }, 0);

                    var fuhe = res.data.map(t => ((t.avg.toFixed(2) / t.max) * 100).toFixed(2)).reverse();
                    this.fuheData = [];
                    for(var i=0;i<time.length;i++) {
                        this.fuheData.push({
                            time: time[i],
                            min: min[i],
                            max: max[i],
                            avg: avg[i],
                            dateMax: dateMax[i],
                            dateMin: dateMin[i],
                            fuhe: fuhe[i],
                        })
                    }
                    this.listLoading = false;

                    var options = {
                        title: {
                            text: '负荷分析',
                            left: 'center',
                            top: 0
                        },
                        grid: {
                            top: 50,
                            left: 40,
                            right: 40,
                            bottom: 50,
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow',
                                label: {
                                    backgroundColor: '#283b56'
                                }
                            }
                        },
                        legend: {
                            data:['平均负荷(kW)','最大负荷(kW)', '最小负荷(kW)', '负荷率(%)'],
                            bottom: 0
                        },
                        dataZoom: {
                            show: false,
                            start: 0,
                            end: 100
                        },
                        xAxis: [
                            {
                                type: 'category',
                                boundaryGap: true,
                                data: time
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                scale: true,
                                min: 0,
                                name: '负荷(kW)',
                                boundaryGap: [0.2, 0.2]
                            },
                            {
                                type: 'value',
                                scale: true,
                                min: 0,
                                name: '负荷率(%)',
                                boundaryGap: [0.2, 0.2]
                            }
                        ],
                        series: [
                            {
                                name:'平均负荷(kW)',
                                type:'bar',
                                itemStyle: {
                                    normal: {
                                        color: '#2f4554'
                                    }
                                },
                                data: avg
                            },
                            {
                                name:'最大负荷(kW)',
                                type:'bar',
                                itemStyle: {
                                    normal: {
                                        color: '#c23531'
                                    }
                                },
                                data: max
                            },
                            {
                                name:'最小负荷(kW)',
                                type:'bar',
                                itemStyle: {
                                    normal: {
                                        color: '#91c7ae'
                                    }
                                },
                                data: min
                            },
                            {
                                name:'负荷率(%)',
                                type:'line',
                                smooth:true,
                                yAxisIndex: 1,
                                itemStyle: {
                                    normal: {
                                        color: '#FFC125'
                                    }
                                },
                                data:fuhe
                            }
                        ]
                    };

                    this.chart1.setOption(options);
                    this.$parent.$parent.$parent.menuHeight = '1000px';
                    //NProgress.done();
                });
            },
        },
        mounted() {
            this.filters.companyId = (this.me.rname === 'ROLE_PLATFORM' || this.me.rname === 'ROLE_ADMIN') ? '' : this.me.companyId;
            this.getCompanies();
            this.getGroups(this.filters.companyId);
        },
        components:{

        }
    }
</script>



// WEBPACK FOOTER //
// Load.vue?6f8026ac